import { captureException } from "@sentry/react";

let config;

let baseConfig = {
  environmentName: "local",

  graphql: "http://localhost:80/graphql",
  flask: "http://localhost:80",
  web: "http://localhost:3000",
  ws: "ws://localhost:80",

  datadog: {
    applicationId: "34e21cab-0f66-4334-9fd6-6a1359eebfce",
    clientToken: "pub7a22ef792d178b3d4d580c1a2b274d43",
    site: "datadoghq.com",
    service: "react",
    env: "local",
    enabled: false,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "allow",
  },

  GOOGLE_MAPS_API_KEY: "AIzaSyDVZISZ91XMR1kpDdgOdBlC_P1EG4Q6dRc",

  stripe: {
    unlimited_price_id_monthly: "price_1QfWuHI2vDgGH9ZgJdwiGl8S",
    unlimited_price_id_yearly: "price_1QfWuaI2vDgGH9ZgYd436n2c",
    companion_snack_pack_price_id: "price_1TP63kI2vDgGH9ZgCpguxbOO",
    companion_small_price_id_monthly:
      "price_1TP64rI2vDgGH9ZgnQ9csN0K",
    companion_large_price_id_monthly:
      "price_1TP67VI2vDgGH9ZgJAL6ruVb",
  },

  intercom: {
    intercom_id: "v8but558",
    intercom_enabled: false,
  },

  mixpanel: {
    id: "2843f411f4738d1a581a578f593c4311",
    enabled: false,
    debug: false,
    cookie_domain: ".scribenote.com",
    cross_subdomain_cookie: true,
  },

  launchdarkly: {
    client_key: "692f4930f2e63c09d716ec4f",
  },

  sentry: {
    dsn: "https://2c03e9d93b444b8281f7d2ddce8c8eab@o362489.ingest.sentry.io/4215838",
    tracesSampleRate: 1.0,
    enabled: false,
  },

  descope: {
    projectId: "P33iCCcxR3OqGGHfCFZ41zmNAybz",
    baseUrl: "https://auth.dev.scribenote.com",
  },

  isTestEnv: false,
};

export function getConfig() {
  if (config) {
    return config;
  }
  try {
    if (!window.__SCRIBENOTE_CONFIG__) {
      console.log(
        "No config found, using environment default config",
      );
      config = { ...baseConfig };
    } else {
      console.log("Config found, using external config");
      let externalConfig = window.__SCRIBENOTE_CONFIG__;
      config = {
        ...baseConfig,
        ...externalConfig,
      };
    }
    if (!config.graphql) {
      throw new Error("Environment configuration is incomplete");
    }
    return config;
  } catch (error) {
    console.error("Error getting configuration");
    captureException(error);
  }
}
